// Datos de productos para Básculas de Colgar
export const basculasColgar = [
  {
    id: 701,
    categoria: 'basculas-colgar',
    nombre: 'BASCULA DE COLGAR CON DISPLAY',
    descripcion: 'Balanza de colgar robusta, diseñada para trabajos exigentes en bodegas, faenas y líneas de producción ',
    descripcion2: 'Su carcasa de aluminio fundido garantiza resistencia a impactos y larga vida útil, mientras que el display LED rojo ofrece una lectura nítida en entornos de alta iluminación. Incorpora funciones operativas clave (Zero, Tara y Hold) para agilizar el pesaje y mejorar la seguridad en maniobras con grúas o polipastos. La batería recargable con cargador externo permite jornadas de trabajo continuas, y la salida serial RS-232 facilita la integración con periféricos o sistemas de registro. Además, incluye control remoto externo con display LCD para visualizar el peso de forma inalámbrica hasta 10 m en línea de vista.',
    imagen: '/imagenes/productos/BasculasColgar/bascula_colgardis1.webp',
    caracteristicas: [
      {
        titulo: 'Características Generales',
        items: [
          '•	Display LED rojo de alta visibilidad para lectura inmediata del peso.',
          '•	Carcasa de aluminio fundido, resistente y durable para uso industrial.',
          '•	Funciones: Zero (cero), Tara y Hold (retención de peso) para asegurar lecturas y agilizar operaciones.',
          '•	Autonomía a batería recargable con sistema de carga externo (mayor flexibilidad operativa).',
          '•	Salida serial RS-232 para conexión con impresoras, indicadores o PC (no incluye software).',
          '•	Control remoto externo con display LCD para visualización inalámbrica del peso, alcance directo 10 m.',
          
        ]
      },
    ],
    opciones: [
      {
        id: 'bascula-colgardis1000kg',
        nombre: '1000KG',        
      },
      {
        id: 'bascula-colgardis3000kg',
        nombre: '3000KG'
      },
      {
        id: 'bascula-colgardis5000kg',
        nombre: '5000KG'
      },
      {
        id: 'bascula-colgardis10000kg',
        nombre: '10000KG'
      }
    ],
    imagenes: [
      '/imagenes/productos/BasculasColgar/bascula_colgardis1.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgardis2.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgardis3.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgardis4.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgardis5.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgardis6.webp'
    ]
  },
  {
    id: 702,
    categoria: 'basculas-colgar',
    nombre: 'BASCULA DE COLGAR',
    descripcion: 'Balanza de colgar para uso intensivo en bodegas y faenas, construida en aluminio fundido para alta resistencia mecánica. ',
    descripcion2: 'Incorpora display LED rojo de 30 mm para lectura nítida a distancia y opera en kilogramos (kg). Sus funciones Zero, Tara y Hold (retención de peso) agilizan maniobras con grúa. La batería recargable ofrece hasta 60 horas de autonomía e incluye sistema de carga externo. Trae control remoto para funciones básicas y programación del equipo. Calidad industrial y certificable según normativa aplicable.',
    imagen: '/imagenes/productos/BasculasColgar/bascula_colgar1.webp',
    caracteristicas: [
      {
        titulo: 'Características Generales',
        items: [
          '•	Unidad de pesaje: kg',
          '•	Display: LED rojo, altura de dígito 30 mm',
          '•	Estructura: Aluminio fundido de alta durabilidad',
          '•	Funciones: Zero, Tara, Hold (retención de peso)',
          '•	Autonomía: hasta 60 h con batería recargable',
          '•	Carga: cargador externo incluido',
          '•	Control remoto: para funciones básicas y programación',
          '•	Uso: industrial (equipo certificable)',
          
        ]
      },
    ],
    opciones: [
      {
        id: 'bascula-colgar1000kg',
        nombre: '1000KG'
      },
      {
        id: 'bascula-colgar3000kg',
        nombre: '3000KG'
      },
      {
        id: 'bascula-colgar5000kg',
        nombre: '5000KG'
      },
      {
        id: 'bascula-colgar10000kg',
        nombre: '10000KG'
      }
    ],
    imagenes: [
      '/imagenes/productos/BasculasColgar/bascula_colgar1.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgar2.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgar3.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgar4.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgar5.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgar6.webp',




    ]
  },

  {
    id: 703,
    categoria: 'basculas-colgar',
    nombre: 'BÁSCULA DE COLGAR PEQUEÑA',
    descripcion: 'Diseñada para medir el peso de objetos suspendidos mediante un gancho. Es un equipo portátil, robusto y fáciles de transportar. ',
    descripcion2: 'Permite medir el peso en kilogramos y libras. Destaca por su alta capacidad, resolución y exactitud, garantizando resultados precisos en cada medición. Incorpora una pantalla digital LCD retroiluminada facilitando la lectura  en condiciones de poca luz.',
    imagen: '/imagenes/productos/BasculasColgar/bascula_colgarpe1.webp',
    caracteristicas: [  
      {
        titulo: 'Características Generales',
        items: [
          '•	Unidades de medida: kg / lb (conversión rápida)',
          '•	Funciones: Pesaje, Tara, Retención de datos (Hold)',
          '•	Pantalla: LCD retroiluminada de alto contraste',
          '•	Alimentación: 3 baterías AA incluidas',
          '•	Materiales: Receptor de carga acero inoxidable; carcasa aluminio fundido',
          '•	Dimensiones: 265 × 81 mm',
          '•	Certificación: ISO 9001:2000 (sistema de gestión de calidad del fabricante)',
          '•	Incluye: Manual de usuario',
          
        ]
      },
    ],
    opciones: [
      {
        id: 'bascula-colgarpe1000kg',
        nombre: '1000KG',        
      },
      {
        id: 'bascula-colgarpe3000kg',
        nombre: '3000KG'
      },
      {
        id: 'bascula-colgarpe5000kg',
        nombre: '5000KG'
      },
      {
        id: 'bascula-colgarpe10000kg',
        nombre: '10000KG'
      }
    ],
    imagenes: [
      '/imagenes/productos/BasculasColgar/bascula_colgarpe1.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgarpe2.webp',
      '/imagenes/productos/BasculasColgar/bascula_colgarpe3.webp',




    ]
  },
  
]
export default basculasColgar;
